import React, { Component } from 'react'
import { Row, Col, Modal, Form, Button } from 'react-bootstrap'
import DateTime from 'react-datetime'
import '../../../../react-datetime.css'

class ManageQuestionModal extends Component {

    render() {
        var yesterday = DateTime.moment().subtract(1, 'day');
        var valid = function (current) {
            return current.isAfter(yesterday);
        };
        return (
            <Modal {...this.props}
                size="lg" centered dialogClassName="reschedule-modal" aria-labelledby="example-modal-sizes-title-lg">
                <style>{`.reschedule-modal .modal-content{border:none;border-radius:16px;box-shadow:0 12px 40px rgba(0,0,0,.18)} .reschedule-modal .modal-header{border-top-left-radius:16px;border-top-right-radius:16px} .reschedule-modal .modal-body{overflow:visible;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.reschedule-modal .rdtPicker{position:absolute;z-index:99999} .reschedule-modal .close{color:#fff;opacity:.9;text-shadow:none;font-size:26px} .reschedule-modal .close:hover{opacity:1}`}</style>
                <Modal.Header closeButton style={{ background: "linear-gradient(135deg,#6366f1,#8b5cf6)", border: "none", padding: "16px 22px" }}>
                    <Modal.Title id="example-modal-sizes-title-lg" className="text-white d-flex align-items-center" style={{ fontSize: 17, fontWeight: 700 }}>
                        <i className="fal fa-calendar-alt mr-2" />Reschedule Online Question Paper
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4" style={{ background: "#f8fafc" }}>
                    {this.props.stateData.currentStep == 2 ? (
                        <div className="d-flex align-items-center mb-3" style={{ background: "#ecfdf5", border: "1px solid #a7f3d0", color: "#047857", borderRadius: 10, padding: "10px 14px", fontSize: 14, fontWeight: 600 }}>
                            <i className="fal fa-check-circle mr-2" />Rescheduled Successfully
                        </div>
                    ) : this.props.stateData.submitError ? (
                        <div className="d-flex align-items-center mb-3" style={{ background: "#fef2f2", border: "1px solid #fecaca", color: "#b91c1c", borderRadius: 10, padding: "10px 14px", fontSize: 14, fontWeight: 600 }}>
                            <i className="fal fa-exclamation-circle mr-2" />{this.props.stateData.submitError}
                        </div>
                    ) : null}
                    <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e5e7eb", boxShadow: "0 2px 12px rgba(0,0,0,0.04)", padding: "24px", minHeight: 360 }}>
                        <Form>
                            <Row>
                                <Form.Group as={Col} lg={6} md={6} sm={12} controlId="StartDate">
                                    <Form.Label className="text-uppercase" style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", letterSpacing: ".4px" }}>
                                        <i className="fal fa-calendar-plus mr-2" style={{ color: "#6366f1" }} />Start Date
                                    </Form.Label>
                                    <DateTime
                                        name="startdate"
                                        dateFormat="DD-MM-YYYY"
                                        inputProps={{ placeholder: 'Ex: 02-04-1995' }}
                                        onChange={this.props.datefunction}
                                        isValidDate={valid}
                                    />
                                    <Form.Text className="form-text text-danger">
                                        {this.props.stateData.formErrors.startdate}
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col} lg={6} md={6} sm={12} controlId="EndDate">
                                    <Form.Label className="text-uppercase" style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", letterSpacing: ".4px" }}>
                                        <i className="fal fa-calendar-check mr-2" style={{ color: "#6366f1" }} />End Date
                                    </Form.Label>
                                    <DateTime
                                        name="enddate"
                                        onChange={this.props.datefunctionend}
                                        dateFormat="DD-MM-YYYY"
                                        inputProps={{ placeholder: 'Ex: 29-05-1995' }}
                                        isValidDate={valid}
                                    />
                                    <Form.Text className="form-text text-danger">
                                        {this.props.stateData.formErrors.enddate}
                                    </Form.Text>
                                </Form.Group>
                            </Row>
                            <div className="d-flex justify-content-end mt-2">
                                <Button
                                    onClick={this.props.ParenthandleFormSubmit}
                                    className="d-flex align-items-center text-uppercase"
                                    style={{ background: "linear-gradient(135deg,#10b981,#059669)", border: "none", borderRadius: 10, fontWeight: 700, padding: "10px 28px", letterSpacing: ".3px" }}>
                                    <i className="fal fa-check mr-2" />Submit
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

export default ManageQuestionModal
